import { motion } from "framer-motion";
import { Star } from "lucide-react";

const quotes = [
  { name: "Marina C.", role: "Corredora amadora", text: "Pela primeira vez uma loja me disse o que eu NÃO precisava comprar. O magnésio mudou meu sono em duas semanas." },
  { name: "Rafael T.", role: "Crossfit há 4 anos", text: "O Ignite é o único pré-treino que não me dá crash. E a curadoria do catálogo economiza meu tempo de pesquisa." },
  { name: "Dra. Paula S.", role: "Nutricionista esportiva", text: "Indico a leve essenza aos meus pacientes pela transparência de rótulo. Coisa rara nesse mercado." },
];

export const Testimonials = () => (
  <section id="depoimentos" data-testid="testimonials-section" className="bg-white py-24 md:py-32 lg:py-40">
    <div className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="mb-20"
      >
        <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">05 · Depoimentos</p>
        <h2 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight">
          Quem treina, <span className="italic font-light text-military">recomenda.</span>
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
        {quotes.map((q, i) => (
          <motion.blockquote
            key={q.name}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: i * 0.15 }}
            className={`md:col-span-4 ${i === 1 ? "md:mt-16" : ""} ${i === 2 ? "md:mt-32" : ""} bg-offwhite border border-military/10 rounded-lg p-10`}
          >
            <div className="flex gap-1 mb-6">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={14} className="fill-military text-military" />
              ))}
            </div>
            <p className="font-serif italic text-xl md:text-2xl text-military-dark leading-relaxed mb-8">"{q.text}"</p>
            <footer>
              <p className="text-sm font-semibold text-military-dark">{q.name}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-military-dark/50 mt-1">{q.role}</p>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
